import { createActions, createState, createReducer } from 'reduxsauce-crud'
import R from 'ramda'

const d = { deep: true }

export const InscriptionsRedux = createActions(
  {
    updateDataAfterInscription: ['data'],
    updateDataAfterDeleteInscription: ['data'],
  },
  {
    prefix: 'INSCRIPTIONS_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = InscriptionsRedux
export const InscriptionsTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})

const updateDataAfterInscription = (state, { data }) => {
  const newInscriptions = R.clone(state.get.results)
  const [student] = newInscriptions.data.filter(child => child.id === data.id)
  const activeStudentIndex = R.findIndex(R.propEq('id', student.id))(newInscriptions.data)
  newInscriptions.data.splice(activeStudentIndex, 1)
  return state.merge({ get: { fetching: false, results: newInscriptions } }, d)
}

const updateDataAfterDeleteInscription = (state, { data }) => {
  const newInscriptions = R.clone(state.get.results)
  const [student] = newInscriptions.filter(child => child.id == data)
  const activeStudentIndex = R.findIndex(R.propEq('id', student.id))(newInscriptions)
  newInscriptions.splice(activeStudentIndex, 1)
  return state.merge({ get: { fetching: false, results: newInscriptions } }, d)
}


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.updateDataAfterInscription]: updateDataAfterInscription,
    [Types.updateDataAfterDeleteInscription]: updateDataAfterDeleteInscription,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/InscriptionsRedux.js